(() => {
  const dialog = document.getElementById('we-quick-dialog');
  if (!dialog || window.WEQuickAdd) return;
  window.WEQuickAdd = true;
  const picker = dialog.querySelector('[data-we-quick-picker]');
  const select = dialog.querySelector('[data-we-quick-variant]');
  const plan = dialog.querySelector('[data-we-quick-plan]');
  const planLabel = dialog.querySelector('[data-we-quick-plan-label]');
  const confirm = dialog.querySelector('[data-we-quick-confirm]');
  const status = dialog.querySelector('[data-we-quick-status]');
  const price = dialog.querySelector('[data-we-quick-price]');
  const image = dialog.querySelector('[data-we-quick-image]');
  const notice = document.querySelector('[data-we-quick-notice]');
  const money = new Intl.NumberFormat(dialog.dataset.locale, { style: 'currency', currency: dialog.dataset.currency });
  let origin, product, request, pending = false, restore = true, noticeTimer;
  const showError = message => {
    notice.textContent = message;
    notice.hidden = false;
    clearTimeout(noticeTimer);
    noticeTimer = setTimeout(() => { notice.hidden = true; }, 8000);
  };
  const option = (value, text, disabled = false) => {
    const node = new Option(text, value);
    node.disabled = disabled;
    return node;
  };
  const updateSelection = () => {
    const variant = product?.variants.find(item => String(item.id) === select.value);
    confirm.disabled = !variant?.available;
    picker.elements.quantity.value = variant?.quantity_rule?.min || 1;
    price.textContent = variant ? money.format(variant.price / 100) : '';
    const src = variant?.featured_image?.src || product?.featured_image;
    if (src) { image.src = src; image.hidden = false; }
    plan.replaceChildren();
    const allocations = variant?.selling_plan_allocations || [];
    plan.hidden = planLabel.hidden = !product?.requires_selling_plan;
    plan.disabled = !product?.requires_selling_plan;
    if (product?.requires_selling_plan) {
      plan.append(option('', dialog.dataset.choose, true));
      allocations.forEach(allocation => {
        const sellingPlan = product.selling_plan_groups?.flatMap(group => group.selling_plans).find(item => item.id === allocation.selling_plan_id);
        if (sellingPlan) plan.append(option(String(sellingPlan.id), sellingPlan.name));
      });
      plan.value = '';
      confirm.disabled = true;
    }
  };
  const fetchProduct = async (button, signal) => {
    const url = new URL(button.href, location.href);
    url.pathname = url.pathname.replace(/\/$/, '') + '.js';
    url.search = '';
    const response = await fetch(url, { headers: { Accept: 'application/json' }, signal });
    if (!response.ok) throw new Error(dialog.dataset.error);
    return response.json();
  };
  const choose = async (button, knownProduct = null) => {
    if (pending) return;
    request?.abort();
    request = new AbortController();
    const current = request;
    origin = button;
    restore = true;
    product = null;
    notice.hidden = true;
    picker.hidden = true;
    image.hidden = true;
    price.textContent = '';
    const card = button.closest('.we-card,.we-guide-wines li,.we-album-wine-row,[data-we-quick-suggestion],.we-fondue-wine-note,.we-guide-region');
    const title = card?.querySelector('h3,strong,.we-album-wine-name');
    dialog.querySelector('h2').textContent = title?.textContent.trim() || dialog.dataset.choose;
    status.textContent = dialog.dataset.loading;
    status.removeAttribute('data-error');
    dialog.showModal();
    dialog.querySelector('[data-we-quick-close]').focus({ preventScroll: true });
    try {
      const data = knownProduct || await fetchProduct(button, current.signal);
      if (request !== current || !dialog.open) return;
      product = data;
      select.replaceChildren(option('', dialog.dataset.choose, true));
      product.variants.forEach(variant => select.append(option(String(variant.id), variant.title + ' · ' + money.format(variant.price / 100) + (variant.available ? '' : ' · ' + dialog.dataset.sold), !variant.available)));
      select.value = '';
      status.textContent = '';
      picker.hidden = false;
      updateSelection();
      select.focus({ preventScroll: true });
    } catch (error) {
      if (error.name === 'AbortError' || request !== current) return;
      status.textContent = dialog.dataset.error;
      status.dataset.error = 'true';
    }
  };
  const add = async (form, button, fromPicker = false) => {
    if (pending || !form.reportValidity() || button.disabled) return;
    pending = true;
    notice.hidden = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    form.setAttribute('aria-busy', 'true');
    if (fromPicker) { restore = false; dialog.close(); }
    try {
      await window.WECartDrawer.add(form, fromPicker ? origin : button);
    } catch (error) {
      if (!document.querySelector('.we-drawer[open]')) showError(error.message || dialog.dataset.error);
    } finally {
      pending = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      form.removeAttribute('aria-busy');
    }
  };
  const addEditorial = async button => {
    if (pending) return;
    pending = true;
    notice.hidden = true;
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-disabled', 'true');
    try {
      const data = await fetchProduct(button);
      if ((dialog.dataset.quoteIds || '').split(',').includes(String(data.id))) throw new Error(dialog.dataset.onRequest);
      const variant = data.variants[0];
      if (data.variants.length === 1 && !data.requires_selling_plan) {
        if (!variant?.available) throw new Error(dialog.dataset.sold);
        const form = document.createElement('form');
        const id = document.createElement('input');
        id.name = 'id'; id.value = variant.id;
        const quantity = document.createElement('input');
        quantity.name = 'quantity'; quantity.value = variant.quantity_rule?.min || 1;
        form.append(id, quantity);
        pending = false;
        await add(form, button);
      } else {
        pending = false;
        await choose(button, data);
      }
    } catch (error) {
      showError(error.message || dialog.dataset.error);
    } finally {
      pending = false;
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
    }
  };
  document.querySelectorAll('.we-fondue-wine-note,.we-guide-region').forEach(card => {
    const link = [...card.querySelectorAll('a[href]')].reverse().find(item => {
      const url = new URL(item.href, location.href);
      return url.origin === location.origin && /\/products\/[^/]+\/?$/.test(url.pathname);
    });
    if (!link || !card.querySelector('img') || card.querySelector('.we-quick-button')) return;
    const button = document.createElement('a');
    button.className = 'we-quick-button';
    button.href = link.href;
    button.setAttribute('data-we-quick-editorial', '');
    const name = card.querySelector('h3,h4,strong')?.textContent.trim();
    button.setAttribute('aria-label', dialog.dataset.add + (name ? ': ' + name : ''));
    button.title = dialog.dataset.add;
    button.append(confirm.querySelector('svg').cloneNode(true));
    const row = link.closest('p') || link.parentElement;
    row.classList.add('we-quick-editorial-actions');
    row.append(button);
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-we-quick-options],[data-we-quick-editorial]');
    if (!button || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (button.hasAttribute('data-we-quick-editorial')) addEditorial(button); else choose(button);
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-we-quick-form]');
    if (!form || !window.WECartDrawer) return;
    event.preventDefault();
    add(form, form.querySelector('button'));
  });
  picker.addEventListener('submit', event => {
    if (!window.WECartDrawer) return;
    event.preventDefault();
    add(picker, confirm, true);
  });
  select.addEventListener('change', updateSelection);
  plan.addEventListener('change', () => { confirm.disabled = !plan.value || !product?.variants.find(item => String(item.id) === select.value)?.available; });
  dialog.querySelector('[data-we-quick-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    request?.abort();
    if (restore && origin?.isConnected) origin.focus({ preventScroll: true });
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
})();
